import { themeVars } from '@tundr/theme';
import { style, styleVariants } from '@vanilla-extract/css';
import { FontIconSize } from './FontIcon.types';

export const iconBaseClass = style({
  display: 'inline-flex',
  fontSize: themeVars.font.size.iconMd,
  verticalAlign: '-0.125em',
});

export const boxedIconClass = style({
  alignItems: 'center',
  justifyContent: 'center',
  width: 25,
  height: 25,
  borderRadius: themeVars.radius.sm,
  backgroundColor: themeVars.colors.neutrals.white,
  color: themeVars.colors.neutrals.black100,
});

export const iconSizeClass = styleVariants({
  [FontIconSize.SM]: {
    fontSize: themeVars.font.size.iconSm,
  },
  [FontIconSize.MD]: {
    fontSize: themeVars.font.size.iconMd,
  },
  [FontIconSize.LG]: {
    fontSize: themeVars.font.size.iconLg,
  },
  [FontIconSize.XL]: {
    fontSize: themeVars.font.size.iconXl,
  },
  [FontIconSize['2XL']]: {
    fontSize: themeVars.font.size.icon2xl,
  },
  [FontIconSize['3XL']]: {
    fontSize: themeVars.font.size.icon3xl,
  },
});
